import { config } from 'config';
import i18n from 'i18nextInstance';
const {
    asyncConsults,
    doctorsRelated,
    turns,
    workplaces
} = config;

export const headers = [{
    key: 'last_name',
    label: i18n.t('Apellido')
}, {
    key: 'first_name',
    label: i18n.t('Nombre')
}, {
    key: 'identification',
    label: i18n.t('DNI')
}, {
    key: 'email',
    label: i18n.t('Email')
}, {
    key: 'parsed_birth_date',
    label: i18n.t('Fecha de Nac.')
}, {
    key: 'parsed_gender',
    label: i18n.t('Sexo')
}, {
    key: 'cellphone_number',
    label: i18n.t('Celular')
}, {
    key: 'parsed_created_at',
    label: i18n.t('Fecha de Alta')
}, {
    display: turns,
    key: 'appointments',
    label: i18n.t('Turnos')
}, {
    display: doctorsRelated,
    key: 'doctors',
    label: i18n.t('Profesionales asociados')
}, {
    display: asyncConsults,
    key: 'consultations',
    label: i18n.t('Mensajes enviados')
}, {
    display: workplaces,
    key: 'parsed_workplace',
    label: i18n.t('Lugar de trabajo')
}].filter(({ display = true }) => !!display);
